import { createTheme } from "@mui/material/styles";

/**
 * ポップで今時な工場シミュレーションゲーム風テーマ。
 * 参考: Big Pharma / Industries of Titan 系のウォームカラー。
 */
export const appTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#ff7a3d", light: "#ffa070", dark: "#d15820", contrastText: "#fff" },
    secondary: { main: "#2ec4b6", light: "#7fe0d4", dark: "#1b8a80", contrastText: "#fff" },
    error: { main: "#e63946" },
    warning: { main: "#f6ae2d" },
    info: { main: "#4895ef" },
    success: { main: "#90be6d" },
    background: {
      default: "#f4efe6",
      paper: "#ffffff",
    },
    text: {
      primary: "#2b2a33",
      secondary: "#6b6776",
    },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Noto Sans JP", "Roboto", sans-serif',
    button: { textTransform: "none", fontWeight: 700 },
    h6: { fontWeight: 700 },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 700,
        },
      },
    },
  },
});
